export const EVENT_BANNER_WIDTH = 1400;
export const EVENT_BANNER_HEIGHT = 550;
export const EVENT_BANNER_ASPECT = EVENT_BANNER_WIDTH / EVENT_BANNER_HEIGHT;
export const EVENT_BANNER_SIZE_LABEL = `${EVENT_BANNER_WIDTH}×${EVENT_BANNER_HEIGHT}px`;
